import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const UpgradeModal = ({ 
  isOpen, 
  onClose, 
  feature = 'this feature',
  usageInfo = {}
}) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/plans');
  };

  const getNextResetDate = () => {
    const now = new Date();
    const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());
    return nextMonth.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-xl shadow-elevated border border-border max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-r from-primary to-secondary rounded-lg flex items-center justify-center">
              <Icon name="Crown" size={20} color="white" />
            </div>
            <div>
              <h2 className="text-lg font-heading font-semibold text-foreground">
                Usage Limit Reached
              </h2>
              <p className="text-sm text-muted-foreground">
                Upgrade to continue using {feature}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Current Usage */}
          <div className="bg-muted/30 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-foreground">Current Usage</span>
              <span className="text-sm text-muted-foreground">
                {usageInfo.usage || 0} / {usageInfo.limit || 0}
              </span>
            </div>
            <div className="w-full bg-background rounded-full h-2">
              <div 
                className="h-2 rounded-full bg-warning transition-all duration-300"
                style={{ width: '100%' }}
              />
            </div>
          </div>

          {/* Reset Information */}
          <div className="text-center space-y-2">
            <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
              <Icon name="Clock" size={16} />
              <span>Your usage will reset on {getNextResetDate()}</span>
            </div>
            <p className="text-xs text-muted-foreground">
              That's about 30 days from now
            </p>
          </div>

          {/* Upgrade Benefits */}
          <div className="space-y-3">
            <h3 className="font-medium text-foreground">Pro Benefits:</h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 bg-success rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="Check" size={12} color="white" />
                </div>
                <span className="text-sm text-muted-foreground">Unlimited news generation</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 bg-success rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="Check" size={12} color="white" />
                </div>
                <span className="text-sm text-muted-foreground">Unlimited fact checking</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 bg-success rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="Check" size={12} color="white" />
                </div>
                <span className="text-sm text-muted-foreground">Unlimited bias detection</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 bg-success rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="Check" size={12} color="white" />
                </div>
                <span className="text-sm text-muted-foreground">Priority support</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center space-x-3 p-6 border-t border-border">
          <Button
            variant="outline"
            className="flex-1"
            onClick={onClose}
          >
            Wait for Reset
          </Button>
          <Button
            className="flex-1 bg-gradient-to-r from-primary to-secondary hover:from-primary/90 hover:to-secondary/90"
            iconName="Crown"
            iconPosition="left"
            onClick={handleUpgrade}
          >
            Upgrade to Pro
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;